export default __webpack_public_path__ + "static/media/grid.021.0fd47cae.jpeg";